var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa-star mr-2 text-warning cursor-pointer",class:_vm.featuredClass,on:{"click":_vm.toggleFeatured}})
}
var staticRenderFns = []

export { render, staticRenderFns }